jQuery(document).ready(function() {
  // Disable the submit button initially
  jQuery(".new-register").prop("disabled", true);

  // Enable the submit button when any field is filled
  jQuery("input[type='first_name'],input[type='last_name'], input[type='email'], input[type='password']").on("input", function() {
    if (
      jQuery("input[type='first_name']").filter(function() { return $.trim(jQuery(this).val()) !== ""; }).length > 0 &&
      jQuery("input[type='last_name']").filter(function() { return $.trim(jQuery(this).val()) !== ""; }).length > 0 &&
      jQuery("input[type='email']").filter(function() { return $.trim(jQuery(this).val()) !== ""; }).length > 0 &&
      jQuery("input[type='password']").filter(function() { return $.trim(jQuery(this).val()).length >= 5; }).length > 0
    ) {
      jQuery(".new-register").prop("disabled", false);
      jQuery(".error-new").addClass("show-n");
    } else {
      jQuery(".new-register").prop("disabled", true);
      jQuery(".error-new").addClass("show");
    }
  });

  // Email format validation
  jQuery("input[type='email']").on("input", function() {
    var email = $.trim(jQuery(this).val());
    var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    if (email === "" || !emailRegex.test(email)) {
      jQuery("#emailError").text("Invalid email format");
      jQuery(".new-register").addClass('show-disb');
    } else {
      jQuery("#emailError").text("");
      jQuery(".new-register").removeClass('show-disb');
    }
  });

  jQuery("input[type='first_name']").on("input", function() {
    var fname = $.trim(jQuery(this).val());
    if (fname === "") {
      jQuery("#first_nameError").text("first name required");
    } else {
      jQuery("#first_nameError").text("");
    }
  });

  jQuery("input[type='last_name']").on("input", function() {
    var lname = $.trim(jQuery(this).val());
    if (lname === "") {
      jQuery("#last_nameError").text("last name required");
    } else {
      jQuery("#last_nameError").text("");
    }
  });
    
  // Password length validation
  jQuery("input[type='password']").on("input", function() {
    var password = $.trim(jQuery(this).val());

    if (password.length < 5) {
      jQuery("#passwordError").text("Password must be at least 5 characters long");
      jQuery(".new-register").addClass('show-new');
    } else {
      jQuery("#passwordError").text("");
        jQuery(".new-register").removeClass('show-new');
    }
  });
  // new contact page validation
});